"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpoints = exports.getPalette = exports.styledComponentsConfig = void 0;
exports.styledComponentsConfig = {
    shouldForwardProp: function (prop, fallback) {
        var foribddenProps = [
            'color',
            'width',
            'height',
            'overflow',
            'mode',
        ];
        if (foribddenProps.includes(prop)) {
            return false;
        }
        return fallback(prop);
    },
};
var getPalette = function (themedPalette, colors, darkDefaults) {
    var light = Object.keys(themedPalette).reduce(function (acc, type) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[type] = themedPalette[type].light, _a)));
    }, {
        colors: colors,
    });
    var reverseColorMap = Object.keys(colors).reduce(function (acc, color) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[colors[color]] = color, _a)));
    }, {});
    var darkDefaultColors = Object.keys(colors).reduce(function (acc, color) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[color] = colors[darkDefaults[color]], _a)));
    }, {});
    var dark = Object.keys(themedPalette).reduce(function (acc, type) {
        var _a;
        var _b = themedPalette[type], themedLight = _b.light, themedDark = _b.dark;
        return __assign(__assign({}, acc), (_a = {}, _a[type] = themedDark || themedLight.map(function (color) { return colors[darkDefaults[reverseColorMap[color]]]; }), _a));
    }, { colors: darkDefaultColors });
    return { light: light, dark: dark };
};
exports.getPalette = getPalette;
var mergeBreakpoints = function (object, source) {
    if (source === void 0) { source = {}; }
    return ({
        fonts: __assign(__assign({}, object.fonts), source.fonts),
        buttons: __assign(__assign({}, object.buttons), source.buttons),
        inputs: __assign(__assign({}, object.inputs), source.inputs),
    });
};
var getBreakpoints = function (breakpoints, themedBreakpoints) {
    var _a;
    var first = breakpoints[0], rest = breakpoints.slice(1);
    return rest.reduce(function (acc, bp, index) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[bp] = mergeBreakpoints(acc[breakpoints[index]], themedBreakpoints[bp]), _a)));
    }, (_a = {},
        _a[first] = themedBreakpoints[first],
        _a));
};
exports.getBreakpoints = getBreakpoints;
